import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "featuredPostImg", "featuredPostTitle" ]

  connect() {
    let _this = this

    // Get the latest featured article from the blog, including title / url / feature image
    fetch("/internal/last-blog-post")
    .then(response => {
      if (!response.ok) {
        throw Error(response.status)
      }
      return response
    })
    .then(response => response.json())
    .then(response => {
      let post = response.posts[0]

      _this.featuredPostImgTarget.setAttribute("src", post.feature_image)

      _this.featuredPostTitleTarget.setAttribute("href", post.url)
      _this.featuredPostTitleTarget.setAttribute("target", "_blank")
      _this.featuredPostTitleTarget.innerText = `${post.title} →`
    })
    .catch(error => {
      console.log(error)
    })
  }
}
